import React from "react";
import checkoutStyles from "repoV2/features/CheckoutPages/CheckoutCommonStyles.module.scss";
import useStateInitBFCache from "repoV2/features/CheckoutPages/utils/useStateInitBFCache";
import CheckoutSubmitButton from "../../../CheckoutSubmitButton/CheckoutSubmitButton";
import LimitedTimeOfferCard from "../../../LimitedTimeOfferCard/LimitedTimeOfferCard";
import usePaymentDetailsForm from "./PaymentDetailsForm.utils";
import SessionDetailsFormGroup from "../FormGroups/modules/SessionDetailsFormGroup/SessionDetailsFormGroup";
import UserDetailsFormGroup from "../FormGroups/modules/UserDetailsFormGroup/UserDetailsFormGroup";
import GSTDetailsFormGroup from "../FormGroups/modules/GSTDetailsFormGroup/GSTDetailsFormGroup";
import CouponCodeFormGroup from "../FormGroups/modules/CouponCodeFormGroup/CouponCodeFormGroup";
import PaymentSummarySection from "../../../PaymentSummarySection/PaymentSummarySection";
import PartPaymentDetails from "../PartPaymentDetails/PartPaymentDetails";
import OrderBumpsFormGroup from "../FormGroups/modules/OrderBumpsFormGroup/OrderBumpsFormGroup";
import DeliveryDetailsFormGroup from "../FormGroups/modules/DeliveryDetailsFormGroup/DeliveryDetailsFormGroup";
import MerchandiseDetailsFormGroup from "../FormGroups/modules/MerchandiseDetailsFormGroup/MerchandiseDetailsFormGroup";
import TermsAndConditionsFormGroup from "../FormGroups/modules/TermsAndConditionsFormGroup/TermsAndConditionsFormGroup";

const PaymentDetailsForm = () => {
    const {
        hideCouponCodeField,
        hideSessionDetailsFormGroup,
        hidePartPaymentsFormGroup,
        hideOrderBumpsFormGroup,
        hideDeliveryDetailsFormGroup,
        hideMerchandiseDetailsFormGroup,
    } = usePaymentDetailsForm();

    useStateInitBFCache();

    return (
        <>
            <div className={checkoutStyles.formWrapper}>
                <LimitedTimeOfferCard />
                {!hideSessionDetailsFormGroup && <SessionDetailsFormGroup />}
                {!hideMerchandiseDetailsFormGroup && (
                    <MerchandiseDetailsFormGroup />
                )}
                <UserDetailsFormGroup />
                {!hideOrderBumpsFormGroup && <OrderBumpsFormGroup />}
                {!hideDeliveryDetailsFormGroup && <DeliveryDetailsFormGroup />}
                <GSTDetailsFormGroup />
                {!hidePartPaymentsFormGroup && <PartPaymentDetails />}
                {!hideCouponCodeField && <CouponCodeFormGroup />}
                <PaymentSummarySection />
                <TermsAndConditionsFormGroup />
                <section className={checkoutStyles.formSubmitBtnWrapper}>
                    <CheckoutSubmitButton type="submit" />
                </section>
            </div>
        </>
    );
};

export default PaymentDetailsForm;
